// extracted by mini-css-extract-plugin
export default {"tab":"tab-module--tab--iZ1+C","title":"tab-module--title--UbnCm","children":"tab-module--children--V6glq","isActive":"tab-module--is-active--qFG07"};